import React from "react";

export const Spinner = ({ className = "" }) => (
  <div
    className={`w-10 h-10 border-2 border-zinc-100 border-t-zinc-400 rounded-full animate-spin ${className}`}
  />
);

export const PageLoader = ({ className = "" }) => (
  <div className={`min-h-screen bg-white flex items-center justify-center ${className}`}>
    <Spinner />
  </div>
);
